import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'; // Falls du Styles willst
import App from './App'; // Das hier verknüpft die App.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);